import SectionWithImages from './SectionWithImages';

export default SectionWithImages;
